import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-dir",
  "use": "icon-dir-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-dir\"><defs><style type=\"text/css\"></style></defs><path d=\"M569.6 256h294.4c51.2 0 96 44.8 96 96v448c0 51.2-44.8 96-96 96h-704c-51.2 0-96-44.8-96-96V192c0-38.4 25.6-64 64-64h313.6c19.2 0 38.4 12.8 51.2 25.6L569.6 256z\" fill=\"#409EFF\" p-id=\"2106\" /><path d=\"M0 262.4h1024v704H0z\" fill=\"#409EFF\" opacity=\".25\" p-id=\"2107\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol